import {
  PACKING_RULES_INDEX_REQUESTED,
  PACKING_RULES_INDEX_SUCCESS,
  PACKING_RULES_INDEX_FAILURE,
  PACKING_RULE_CREATE_REQUESTED,
  PACKING_RULE_CREATE_SUCCESS,
  PACKING_RULE_CREATE_FAILURE,
  PACKING_RULE_UPDATE_REQUESTED,
  PACKING_RULE_UPDATE_SUCCESS,
  PACKING_RULE_UPDATE_FAILURE,
  PACKING_RULE_DELETE_REQUESTED,
  PACKING_RULE_DELETE_SUCCESS,
  PACKING_RULE_DELETE_FAILURE,
  PACKING_RULE_FILE_UPLOAD_REQUESTED,
  PACKING_RULE_FILE_UPLOAD_SUCCESS,
  PACKING_RULE_FILE_UPLOAD_FAILURE,
} from '../types';

const INITIAL_STATE = {
  packingRules: [],
  newPackingRule: null,
  updatedPackingRule: null,
  isFetching: false,
  isCreating: false,
  isUpdating: false,
  isUploadingFile: false,
  status: 'waiting',
  errors: null
};

const packingRules = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case PACKING_RULES_INDEX_REQUESTED:
      return Object.assign({}, state, {
        packingRules: [],
        newPackingRule: null,
        updatedPackingRule: null,
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case PACKING_RULES_INDEX_SUCCESS:
      return Object.assign({}, state, {
        packingRules: action.payload.packing_rules || [],
        isFetching: false,
        status: 'success',
        errors: null
      });

    case PACKING_RULES_INDEX_FAILURE:
      return Object.assign({}, state, {
        packingRules: [],
        isFetching: false,
        status: 'error',
        errors: action.error
      });


    case PACKING_RULE_CREATE_REQUESTED:
      newState.isCreating = true;
      newState.newPackingRule = null;
      newState.updatedPackingRule = null;
      newState.errors = null;
      return newState;

    case PACKING_RULE_CREATE_SUCCESS:
      newState.isCreating = false;
      newState.newPackingRule = action.payload.rule;
      newState.packingRules = [...newState.packingRules, action.payload.rule];
      return newState;

    case PACKING_RULE_CREATE_FAILURE:
      newState.isCreating = false;
      newState.errors = 'Could not create packing rule';
      return newState;


    case PACKING_RULE_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.newPackingRule = null;
      newState.updatedPackingRule = null;
      newState.errors = null;
      return newState;

    case PACKING_RULE_UPDATE_SUCCESS:
      newState.isUpdating = false;
      newState.updatedPackingRule = action.payload.rule;
      newState.packingRules = newState.packingRules.map(rule =>
        rule.id === action.payload.rule.id ? action.payload.rule : rule
      );
      return newState;

    case PACKING_RULE_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Could not update packing rule';
      return newState;


    case PACKING_RULE_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.packingRules = newState.packingRules.filter(rule => rule.id !== action.packingRuleId);
      newState.errors = null;
      return newState;

    case PACKING_RULE_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case PACKING_RULE_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to delete packing rule';
      return newState;


    case PACKING_RULE_FILE_UPLOAD_REQUESTED:
      newState.isUploadingFile = true;
      newState.errors = null;
      return newState;

    case PACKING_RULE_FILE_UPLOAD_SUCCESS:
      newState.isUploadingFile = false;
      return newState;

    case PACKING_RULE_FILE_UPLOAD_FAILURE:
      newState.isUploadingFile = false;
      newState.errors = 'Failed to upload rule file';
      return newState;

    default:
      return state;
  }
}

export default packingRules;
